import React, { useEffect, useState } from "react";
import { API_GET_CONFIG, API_ADD_CONFIG } from "../../../api/account.service";
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from "primereact/tooltip";
import { Message } from "primereact/message";

const ChatSetting = () => {
  const [enterIsSend, setEnterIsSend] = useState(false);
  const [loading, setLoading] = useState(true);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const data = await API_GET_CONFIG();
        if (data) {
          setEnterIsSend(data.enterIsSend);
        }
      } catch (error) {
        console.error("Error fetching config:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  const handleUpdate = async (value) => {
    setEnterIsSend(value);
    setStatusMessage(
      value
        ? "Enter to Send Enabled. Pressing Enter will send the message."
        : "Enter to Send Disabled. Pressing Enter will add a new line."
    );

    try {
      const response = await API_ADD_CONFIG({ enterIsSend: value });
      const data = await response.json();
      if (!data.success) {
        console.error("Error updating config:", data.message);
      }
    } catch (error) {
      console.error("Error updating config:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-4 border rounded-lg shadow-lg bg-white w-[600px]">
      <div className="flex items-center gap-2">
        <span className="font-semibold">Enter is Send</span>
        <i
          className="pi pi-info-circle text-gray-500"
          data-pr-tooltip="Enable or disable sending messages using Enter"
        ></i>
      </div>
      <Tooltip target=".pi-info-circle" />

      <div className="mt-3 flex gap-4">
        <div>
          <RadioButton
            inputId="enable"
            name="enterIsSend"
            value={true}
            onChange={() => handleUpdate(true)}
            checked={Boolean(enterIsSend) === true}
          />
          <label htmlFor="enable" className="ml-2">
            Enable
          </label>
        </div>
        <div>
          <RadioButton
            inputId="disable"
            name="enterIsSend"
            value={false}
            onChange={() => handleUpdate(false)}
            checked={Boolean(enterIsSend) === false}
          />
          <label htmlFor="disable" className="ml-2">
            Disable
          </label>
        </div>
      </div>

      {statusMessage && (
        <div className="flex items-center gap-2 mt-3 p-2 border rounded-lg bg-blue-50 text-gray-800">
          <i className="pi pi-info-circle text-blue-500"></i>
          <span>{statusMessage}</span>
        </div>
      )}
    </div>
  );
};

export default ChatSetting;
